import { render } from "./ShowProcess.vue?vue&type=template&id=580bb177"
import script from "./ShowProcess.vue?vue&type=script&lang=js"
export * from "./ShowProcess.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/packing_house/process/show_process.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fpacking_house%2Fprocess%2Fharvested_batches%2FShowProcess.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__